import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  HttpRequestMethods,
  IDP_APPS,
  TEN_SECOND_TIMEOUT
} from '../../constants/utils';
import { EndpointKeysCommon } from '../../constants/utils/app.constants';
import { News } from '../../models/news/news.interfaces';
import { HttpHeadersPayload, ReplaceItem } from '../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../utils';
@Injectable({
  providedIn: 'root'
})
export class NewsService {
  http = inject(HttpClient);
  config = inject(AppConfigService);
  news$!: Observable<News[]>;

  private headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/json'
  };

  _errorHandler = handleError.bind(this);

  getNews = (): Observable<News[]> => {
    if (this.news$) {
      return this.news$;
    } else {
      this.news$ = this.initAPI().pipe(shareReplay());
      return this.news$;
    }
  };

  initAPI = (): Observable<News[]> => {
    const url = this.config.getConfig('HEADER')?.['APP_RSS_NEWS_URL'] || '';

    const finalUrl: ReplaceItem[] = [
      {
        src: '/content/dam/delta-applications/login/auth-config.json',
        target: url
      }
    ];

    return new ApiBuilder<undefined, News[]>(this.http, this.config)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon.APP_AUTH_CONFIG_JSON)
      .overrideEndpoint(finalUrl)
      .method(HttpRequestMethods['GET'])
      .httpHeaders(this.headerInfo)
      .errorHandler(this._errorHandler)
      .timeOut(TEN_SECOND_TIMEOUT)
      .library('SITE_WIDE_NEWS')
      .create();
  };
}
